export default "__VITE_ASSET__rEfqdv09__"